import type { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  StyledFallbackMap,
  StyledMessageWrapper,
  StyledClockIcon,
  StyledButton,
} from './FallbackMap.styles';
import { MediaQuery } from '../../../styles/mediaQuery';
import map from '../../../assets/images/fallback-map.jpg';
import { Image } from '../../atoms/Image/Image';
import { Heading, HeadingType } from '../../atoms/Heading/Heading';
import { ListViewButton } from '../../molecules/ListViewButton/ListViewButton';

export function FallbackMap(): ReactElement {
  return (
    <StyledFallbackMap>
      <Image
        alt="Fallback map background"
        src={map}
        cover
        source={[
          {
            media: MediaQuery.Small,
            srcset: map,
          },
        ]}
      />
      <ListViewButton />
      <StyledMessageWrapper>
        <StyledClockIcon />
        <Heading type={HeadingType.H1}>
          <strong>
            <FormattedMessage
              id="map-fallback-heading"
              description="fallback heading"
              defaultMessage="Map is not responding"
            />
          </strong>
          <FormattedMessage
            id="map-fallback-subheading"
            description="fallback subheading"
            defaultMessage="Please try again in 5 minutes"
          />
        </Heading>
        <StyledButton
          onClick={() => {
            // eslint-disable-next-line no-restricted-globals
            location.reload();
          }}
        >
          <FormattedMessage
            id="map-fallback-button-reload"
            description="reload button"
            defaultMessage="Reload Map"
          />
        </StyledButton>
      </StyledMessageWrapper>
    </StyledFallbackMap>
  );
}
